// @flow

import assert from 'assert';

import _ from 'lodash';

import type { QPromise } from 'types/q';

import Q from 'q';

import Dictionaries from './js/dictionaries';
import Controller from './js/controller-modal';

import 'ko-component-fio-input';

import { feedbackModalData as feedbackModalDataDictionary} from 'rgs-dictionary';

import { profile } from 'myrgs-auth-helpers';

export interface CalculatorFeedbackModalInterface {
	show (): void;
	on (event: 'enrichComplaintContext', handler: (Object) => void): void;
	loadPrefilling (Object): void;
}

function init (options) {
	const dictsReady = feedbackModalDataDictionary.ready()
		.then(( Data ) => {
			const dicts = new Dictionaries();
			dicts.loadData(Data);
			return dicts;
		});

	return Q.all([
		dictsReady,
		profile.updateAtLeastOnce(),
	])
	.spread((dictionaries) => {
		const ctrl = new Controller(_.defaults({
			dictionaries,
			profile,
		}, options));
		require('debug-globals').extend({ calculatorFeedbackModalController: ctrl });
		return ctrl;
	});
}

class CalculatorFeedbackModalLegacyStub {
	_init: QPromise<CalculatorFeedbackModalInterface>;

	constructor (options) {
		this._init = init(options);
		this._init.done();

		console.warn('`new SupportModal` is depricated, use `init` instead');
	}

	loadPrefilling (data) {
		this._init = this._init.then((ctrl) => {
			ctrl.loadPrefilling(data);
			return ctrl;
		});
		this._init.done();
	}

	on (eventName, callback) {
		assert(
			eventName === 'enrichComplaintContext',
			'This stub only supports `enrichComplaintContext` event. Switch to new API please.'
		);

		this._init = this._init.then((ctrl) => {
			ctrl.on('enrichComplaintContext', callback);
			return ctrl;
		});
		this._init.done();
	}

	show () {
		this._init = this._init.then((ctrl) => {
			ctrl.show();
			return ctrl;
		});
		this._init.done();
	}
}

module.exports = _.extend(CalculatorFeedbackModalLegacyStub, { init });
